import { render, staticRenderFns } from "./matchinfo.vue?vue&type=template&id=fbdd03b4&scoped=true&"
import script from "./matchinfo.ts?vue&type=script&lang=ts&"
export * from "./matchinfo.ts?vue&type=script&lang=ts&"
import style0 from "./matchinfo.scss?vue&type=style&index=0&id=fbdd03b4&lang=scss&scoped=true&"
import style1 from "./matchinfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdd03b4",
  null
  
)

export default component.exports